import React, { useState } from 'react';
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer, BringzzButton, BringzzIcon, BringzzText, BringzzInput
} from "@bringzz/components";
import { useAuth } from 'context/AuthContext';
import useRequest from 'hooks/useRequest';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

let state = {
    checked: (
        <BringzzIcon
            icon="IconCheck"
            library="Custom"
            className="h-5 w-5 p-1 bg-magic-lilac text-light rounded-full"
            size="12"
        />
    ),
    unChecked: (
        <div></div>
    ),
};

const EditEmailView = () => {
    const { user, refreshUserData } = useAuth();
    const { backPress, navigate } = useNavigation();
    const { t } = useTranslation();
    const [email, setEmail] = useState(user.email || "");
    const [isValidEmail, setIsValidEmail] = useState(false);
    const { sendRequest, loading } = useRequest();

    const handleSave = async () => {
        if (!isValidEmail) {
            toast.error('Please enter a valid email address');
            return;
        }

        if (email === user.email) {
            toast.error('New email must be different from current email');
            return;
        }

        try {
            const response = await sendRequest({
                method: 'POST',
                url: `/module/token/createEmailChangeToken`,
                data: {
                    newEmail: email,
                    language: 'en'
                }
            });

            if (response.status === 'success') {
                toast.success('Verification code sent to your new email address!');
                navigate(`/settings/account/email/verify?email=${email}&userId=${user.id}`, false);
            } else {
                toast.error(response.message || 'Failed to send verification code. Please try again.');
            }
        } catch (error) {
            console.error('Error sending verification code:', error);
            toast.error('Failed to send verification code. Please try again.');
        }
    }

    return (
        <BringzzPageContainer
            header={{
                left: <BringzzIcon
                    size="22"
                    icon="IconChevronLeft"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: <BringzzText tag='h2'>{t('component.account.email.title')}</BringzzText>,
            }}
            footer={
                <div className='pb-28 px-6'>
                    <BringzzButton
                        size='lg'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        onClick={handleSave}
                        disabled={!isValidEmail || email === user.email || loading}
                    >
                        {t('common.save')}
                    </BringzzButton>
                </div>
            }
        >
            <div className='p-6 space-y-4'>
                <BringzzInput
                    id='email'
                    label={t('component.account.email.email_address')}
                    containerClassname="w-full"
                    placeholder={t('component.account.email.email_placeholder')}
                    defaultValue={user.email}
                    onChange={(e, valid, value) => {
                        setEmail(value);
                        setIsValidEmail(valid);
                    }}
                    type="email"
                />
                <BringzzText tag="p" className="text-sm text-gray-500">
                    {t('component.account.email.verification_note')}
                </BringzzText>
            </div>
        </BringzzPageContainer>
    );
}

export default EditEmailView;
